export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DashboardInfoWidgets.vue?vue&type=template&id=731bb1c0&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/dashboard/DashboardInfoWidgets.vue?vue&type=template&id=731bb1c0&scoped=true
// module id = aviI
// module chunks = 41